class CustomPopup extends HTMLElement {
  constructor() {
    super();

    this._wrap = this.querySelector('.custom-popup__wrap');
    this._closeBtn = this.querySelector('.custom-popup__close');
  }

  connectedCallback() {
    if (this.hasAttribute('open')) {
      this.open();
    }

    if (this._closeBtn) {
      this._closeBtn.addEventListener('click', () => this.close());
    }

    this.addEventListener('click', this.handleClick.bind(this));

    if (this.id) {
      document.querySelectorAll(`a[href="#${this.id}"]`).forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          this.open();
          this.activeTrigger = e.currentTarget;
          link.classList.add('popup-trigger--active');
        });
      });
    }
  }

  handleClick(e) {
    if (e.target.matches('.custom-popup__close') || e.target.closest('.custom-popup__close') || e.target.matches('.custom-popup')) {
        this.close();
    }
  }

  disconnectedCallback() {
    this._cleanup();
  }

  open() {
    this.setAttribute('open', '');
    document.addEventListener('keydown', this._onKeydown);
  }

  close() {
    this.removeAttribute('open');
    document.documentElement.style.overflow = '';
    this._cleanup();
    this.activeTrigger.classList.remove('popup-trigger--active');
  }

  _onKeydown = (e) => {
    if (e.key === 'Escape' && this.hasAttribute('open')) {
      this.close();
    }
  };

  _onClickOutside = (e) => {
    if (!this.contains(e.target) && this._wrap && !this._wrap.contains(e.target)) {
      this.close();
    }
  };

  _cleanup() {
    document.removeEventListener('keydown', this._onKeydown);
  }
}

if (!customElements.get('custom-popup')) {
  customElements.define('custom-popup', CustomPopup);
}


class NewsletterPopup extends CustomPopup {
  connectedCallback() {
    super.connectedCallback();

    if (this._shouldAutoOpen()) {
      setTimeout(() => {
        this.open();
      }, 100);
    }
  }

  _shouldAutoOpen() {
    const url = new URL(window.location);
    const customerPosted = url.searchParams.get('customer_posted') === 'true';
    const hash = url.hash.replace('#', '');
    return customerPosted && hash === 'contact_form';
  }
}

if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', NewsletterPopup);
}